import $ from 'jquery';
import Slider, {
  cssClassLazyloadOnSlide,
  cssClassSwiperSlide,
} from '../../js/modules/Slider.mjs';
import {
  gridBreakpoints,
  gridGutterWidth,
} from '../../js/utilities/media-queries.mjs';

const $sliders = $('.js_ef-collection-teaser-circle');

$sliders.each((index, slider) => {
  const cssClassCentered = 'js_slider-centered';
  const $slider = $(slider);
  const $sliderWrapper = $slider.find('.ef-collection-teaser-circle__slider-wrapper');
  const $sliderSlides = $slider.find('.ef-collection-teaser-circle__slider-slide');
  const SliderCollectionTeaserCircle = new Slider({
    namespace: 'CollectionTeaserCircle',
    sliderNode: slider,
    $wrapper: $sliderWrapper,
    swiperConfigOverride: {
      autoHeight: true,
      breakpoints: {
        [gridBreakpoints.xs]: {
          slidesPerView: 1,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.md]: {
          slidesPerView: 2,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.lg]: {
          slidesPerView: 3,
          spaceBetween: gridGutterWidth
        }
      }
    },
    callbacks: {
      onInitStart() {
        $sliderWrapper.addClass('no-gutters').removeClass(cssClassCentered);
        $sliderSlides.addClass(cssClassSwiperSlide);
      },
      onDestroy() {
        $sliderWrapper.removeClass('no-gutters').addClass(cssClassCentered);
        $sliderSlides.removeClass(cssClassSwiperSlide);
      },
    },
  });

  if (SliderCollectionTeaserCircle.slidesDontFitIntoWrapper()) {
    SliderCollectionTeaserCircle.init();
  } else {
    $slider.find(`.${cssClassLazyloadOnSlide}`).addClass('lazyload');
  }
  SliderCollectionTeaserCircle.attachResize();
});
